import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import PropertyContactsList from './PropertyContactsList';
import PropertyContactsSearch from './PropertyContactsSearch';
import { H4 } from '@styled';

// Functionality
import useEditPropertyContacts from '@hooks/useEditPropertyContacts';

const PropertyContacts = ({ propertyId, contacts: contactsInitial }) => {
    const [contacts, setContacts] = useState(contactsInitial.map(c => c.id));
    const [isUpdating, setIsUpdating] = useState(false);

    const [updatePropertyContacts] = useEditPropertyContacts({
        onCompleted: response => {
            setContacts(response.updateProperty.contacts.map(c => c.id));
            setIsUpdating(false);
        },
    });

    const addContact = contact => {
        if (isUpdating) {
            return;
        }

        setIsUpdating(true);
        updatePropertyContacts({ variables: { id: propertyId, contacts: [...contacts, contact.graphId] } });
    };

    const removeContact = contact => {
        if (isUpdating) {
            return;
        }

        const currentContacts = [...contacts];

        if (contact.graphId) {
            const index = currentContacts.indexOf(contact.graphId);
            if (index !== -1) {
                currentContacts.splice(index, 1);
            }
        }

        setIsUpdating(true);
        updatePropertyContacts({ variables: { id: propertyId, contacts: currentContacts } });
    };

    return (
        <div>
            <H4 className="font-weight-bold mb-1.25rem">Additional Property Contacts</H4>
            <PropertyContactsSearch onContactSelect={addContact} />
            <PropertyContactsList contacts={contacts} onContactRemove={removeContact} />
        </div>
    );
};

PropertyContacts.propTypes = {
    propertyId: PropTypes.string.isRequired,
    contacts: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
        })
    ),
};

export default PropertyContacts;
